import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import CopyIcon from '@mui/icons-material/FileCopy'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemText, Paper, Typography } from '@mui/material'
import { DataGrid, GridCellParams, GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { CategoryPropsType, CategoryType } from '../../../api/appAPI'
import { saveGridStateInLocalStorage } from '../../../common/helpers'
import { StateType } from '../../../redux/store'
import { EnqueueSnackbarType } from '../../common/Helpers'
import { addCategory, actions as appActions, copyCategory, deleteCategory, editCategory } from './../../../redux/appReducer'
import DefineCategory from './DefineCategory'
import EditCategory from './EditCategory'

interface IProps {
    categoriesList: CategoryType[]
    activeCategoryId: number
    categoryGridVisibilityModel: GridColumnVisibilityModel | undefined
    categoryGridSortModel: GridSortModel | undefined
    categoryGridFilterModel: GridFilterModel | undefined

    setCategoryGridVisibilityModel(model: GridColumnVisibilityModel | undefined): void
    setCategoryGridSortModel(model: GridSortModel | undefined): void
    setCategoryGridFilterModel(model: GridFilterModel | undefined): void
    addCategory(categoryProps: CategoryPropsType, enqueueSnackbar: EnqueueSnackbarType): void
    editCategory(id: number, categoryProps: CategoryPropsType, enqueueSnackbar: EnqueueSnackbarType): void
    copyCategory(id: number, enqueueSnackbar: EnqueueSnackbarType): void
    deleteCategory(id: number, enqueueSnackbar: EnqueueSnackbarType): void
    setActiveCategoryId(id: number): void
}

const CategoriesTab: FC<IProps> = props => {

    const [activeCategory, setActiveCategory] = useState<undefined | CategoryType>(props.categoriesList.find(m => m.id === props.activeCategoryId))
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [deleteID, setDeleteID] = useState<null | number>(null)

    const handleDeleteCategoryClick = (id: number) => {
        setDeleteID(id)
        setDeleteDialogOpen(true)
    }

    const handleDeleteDialogClose = () => {
        setDeleteID(null)
        setDeleteDialogOpen(false)
    }

    const handleDeleteDialogDeleteClick = () => {
        if (deleteID)
            props.deleteCategory(deleteID, enqueueSnackbar)
        handleDeleteDialogClose()
    }

    useEffect(() => {
        setActiveCategory(props.categoriesList.find(h => h.id === props.activeCategoryId))
    }, [props.activeCategoryId])

    useEffect(() => {
        saveGridStateInLocalStorage({ visibilityModel: props.categoryGridVisibilityModel, sortModel: props.categoryGridSortModel, filterModel: props.categoryGridFilterModel }, 'category')
    }, [props.categoryGridVisibilityModel, props.categoryGridSortModel, props.categoryGridFilterModel])

    const { enqueueSnackbar } = useSnackbar()

    return (
        <Box
            display='flex'
            style={{ height: window.innerHeight - 48 * 2 }}
        >
            <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                pt={2}
                style={{ borderRight: 'solid 1px black', width: '50%' }}
            >
                <Typography variant='h6'>Cabinet Category List</Typography>


                <Paper style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
                    <List component="nav" style={{ padding: 0 }}>
                        <ListItem button onClick={() => { props.setActiveCategoryId(0) }}>
                            <ListItemText primary='New Category' />
                            <AddIcon />
                        </ListItem>
                        <Divider />
                    </List>
                </Paper>

                <DataGrid
                    style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}
                    columns={[
                        { field: 'id', headerName: 'id', width: 100 },
                        { field: 'date', headerName: 'Last Modified', type: 'datetime', minWidth: 160 },
                        { field: 'name', headerName: 'Name', width: 150 },
                        { field: 'displayName', headerName: 'Display Name', width: 150 },
                        { field: 'forCorner', headerName: 'For Corner', width: 150 },
                        // { field: 'retailWidthValues', headerName: 'Retail Width Values', width: 150 },
                        // { field: 'retailWidthDefault', headerName: 'Retail Width Default', type: 'number', width: 100 },
                        // { field: 'retailHeightValues', headerName: 'Retail Height Values', width: 150 },
                        // { field: 'retailHeightDefault', headerName: 'Retail Height Default ', type: 'number', width: 100 },
                        // { field: 'retailDepthValues', headerName: 'Retail Depth Values', width: 150 },
                        // { field: 'retailDepthDefault', headerName: 'Retail Depth Default', type: 'number', width: 100 },
                        // { field: 'dealerWidthValues', headerName: 'Dealer Width Values', width: 150 },
                        // { field: 'dealerWidthDefault', headerName: 'Dealer Width Default', type: 'number', width: 100 },
                        // { field: 'dealerHeightValues', headerName: 'Dealer Height Values', width: 150 },
                        // { field: 'dealerHeightDefault', headerName: 'Dealer Height Default', type: 'number', width: 100 },
                        // { field: 'dealerDepthValues', headerName: 'Dealer Depth Values', width: 150 },
                        // { field: 'dealerDepthDefault', headerName: 'Dealer Depth Default', type: 'number', width: 100 },
                        // { field: 'designerWidthValues', headerName: 'Designer Width Values', width: 150 },
                        // { field: 'designerWidthDefault', headerName: 'Designer Width Default', type: 'number', width: 100 },
                        // { field: 'designerHeightValues', headerName: 'Designer Height Values', width: 150 },
                        // { field: 'designerHeightDefault', headerName: 'Designer Height Default', type: 'number', width: 100 },
                        // { field: 'designerDepthValues', headerName: 'Designer Depth Values', width: 150 },
                        // { field: 'designerDepthDefault', headerName: 'Designer Depth Default', type: 'number', width: 100 },
                        {
                            field: 'actions',
                            headerName: 'Actions',
                            filterable: false,
                            sortable: false,
                            renderCell: (params: GridCellParams) => <Box onClick={(e) => {
                                e.stopPropagation() // don't select this row after clicking 
                            }}>
                                <IconButton edge="end" onClick={() => { props.copyCategory(parseInt(params.id.toString()), enqueueSnackbar) }}>
                                    <CopyIcon />
                                </IconButton>
                                <IconButton edge="end" onClick={() => { handleDeleteCategoryClick(parseInt(params.id.toString())) }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Box>,
                            width: 100,
                        }
                    ]}
                    // hideFooterPagination
                    rows={
                        props.categoriesList.map(category => ({
                            id: category.id,
                            date: new Date(category.date),
                            name: category.name,
                            displayName: category.displayName,
                            forCorner: category.forCorner ? '✓' : '',
                            // retailWidthValues: category.retail.width.values.join(','),
                            // retailWidthDefault: category.retail.width.default,
                            // retailHeightValues: category.retail.height.values.join(','),
                            // retailHeightDefault: category.retail.height.default,
                            // retailDepthValues: category.retail.depth.values.join(','),
                            // retailDepthDefault: category.retail.depth.default,
                            // dealerWidthValues: category.dealer.width.values.join(','),
                            // dealerWidthDefault: category.dealer.width.default,
                            // dealerHeightValues: category.dealer.height.values.join(','),
                            // dealerHeightDefault: category.dealer.height.default,
                            // dealerDepthValues: category.dealer.depth.values.join(','),
                            // dealerDepthDefault: category.dealer.depth.default,
                            // designerWidthValues: category.designer.width.values.join(','),
                            // designerWidthDefault: category.designer.width.default,
                            // designerHeightValues: category.designer.height.values.join(','),
                            // designerHeightDefault: category.designer.height.default,
                            // designerDepthValues: category.designer.depth.values.join(','),
                            // designerDepthDefault: category.designer.depth.default,
                        }))
                    }
                    onRowClick={(param) => {
                        props.setActiveCategoryId(parseInt(param.id.toString()))
                    }}

                    columnVisibilityModel={props.categoryGridVisibilityModel}
                    onColumnVisibilityModelChange={(model) => {
                        props.setCategoryGridVisibilityModel(model)
                    }}

                    sortModel={props.categoryGridSortModel}
                    onSortModelChange={(model) => {
                        if (JSON.stringify(model) !== JSON.stringify(props.categoryGridSortModel))
                            props.setCategoryGridSortModel(model)
                    }}

                    filterModel={props.categoryGridFilterModel}
                    onFilterModelChange={(model) => {
                        if (JSON.stringify(model) !== JSON.stringify(props.categoryGridFilterModel))
                            props.setCategoryGridFilterModel(model)
                    }}

                    rowSelectionModel={props.activeCategoryId}
                />
            </Box>
            <Dialog
                open={deleteDialogOpen}
            >
                <DialogTitle>Delete Material Group</DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to delete <b>"{
                            props.categoriesList.find(category => category.id === deleteID)?.name
                        }"</b> category?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteDialogDeleteClick}
                        color="secondary"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            {activeCategory === undefined
                ? <DefineCategory addCategory={props.addCategory} />
                : <EditCategory category={activeCategory} editCategory={props.editCategory} />
            }
        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    categoriesList: state.appReducer.categoriesList,
    activeCategoryId: state.appReducer.activeCategoryId,
    categoryGridVisibilityModel: state.appReducer.categoryGrid.visibilityModel,
    categoryGridSortModel: state.appReducer.categoryGrid.sortModel,
    categoryGridFilterModel: state.appReducer.categoryGrid.filterModel,
})

export default connect(mapStateToProps, {
    setCategoryGridVisibilityModel: appActions.setCategoryGridVisibilityModel,
    setCategoryGridSortModel: appActions.setCategoryGridSortModel,
    setCategoryGridFilterModel: appActions.setCategoryGridFilterModel,
    setActiveCategoryId: appActions.setActiveCategoryId,
    addCategory, editCategory, copyCategory, deleteCategory
})(CategoriesTab)